// app/core/modules/apollo-angular/graphql.config.ts

import { HttpLink } from 'apollo-angular/http';
import { HttpHeaders } from '@angular/common/http';
import { provideNamedApollo } from 'apollo-angular';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import { createUploadLink } from 'apollo-upload-client';
//
// We will have the need to do multiple connections
//
// const uriContentful = environment.graphql.contentful.url;
const uriGateway = environment.graphql.gateway.url; // we are going to stich our microservices here.
const uriGeography = environment.graphql.geography.url;
const uriProject = environment.graphql.project.url;
const uriRbs = environment.graphql.rbs.url;
const uriWageData = environment.graphql.wagedata.url;

export const apolloProviderConfig = provideNamedApollo(() => {
  const httpLink = inject(HttpLink);

  return {
    /**
     * use `default` client according the apollo-angular
     * https://the-guild.dev/graphql/apollo-angular/docs/recipes/multiple-clients
     *
     * @todo - check with the team for the best approach
     */
    default: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: uriGateway,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    },
    GatewayGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: uriGateway,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    },
    GeographyGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: uriGeography,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    },
    ProjectGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: uriProject,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    },
    RBSGraphQL: {
      cache: new InMemoryCache(),
      link: httpLink.create({
        uri: uriRbs,
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }),
    },
    WageGraphQL: {
      cache: new InMemoryCache(),
      link: createUploadLink({
        uri: uriWageData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    },
  };
});
